import React from 'react'
import {
   AIPoweredLogisticsAnalyticsIcon,
   ContinuousSupportIcon,
   CustomLogisticsSoftwareIcon,
   OmnichannelUserExperienceIcon,
   ScalableSolutionsIcon,
   SeamlessIntegrationIcon,
   SecureCompliantPlatformsIcon,
   SupplySecureCompliantPlatformsIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: 'Custom Logistics Software',
      subtitle: 'Tailored Solutions for Freight & Transportation',
      description:
         'We build custom logistics applications, including TMS, WMS, freight tracking, and AI-driven supply chain automation, ensuring optimized operations and cost reduction.',
      icon: <CustomLogisticsSoftwareIcon />,
   },
   {
      title: 'AI-Powered Logistics Analytics',
      subtitle: 'Predictive Insights & Performance Optimization',
      description:
         'We implement AI-powered logistics analytics that track shipment trends, fuel usage, and delivery performance, helping businesses reduce costs and improve efficiency.',
      icon: <AIPoweredLogisticsAnalyticsIcon />,
   },
   {
      title: 'Secure & Compliant Solutions',
      subtitle: 'End-to-End Data Security & Compliance',
      description:
         'We ensure GDPR, ISO 27001, and supply chain compliance standards, integrating blockchain-based smart contracts and encryption protocols for secure transactions.',
      icon: <SupplySecureCompliantPlatformsIcon />,
   },
   {
      title: 'Seamless System Integration',
      subtitle: 'ERP, CRM & IoT Connectivity',
      description:
         'We develop cloud-based logistics platforms that seamlessly integrate with ERP, CRM, GPS tracking systems, AI analytics, and IoT sensors, ensuring real-time supply chain visibility.',
      icon: <SeamlessIntegrationIcon />,
   },
   {
      title: 'Scalable Cloud-Based Infrastructure',
      subtitle: 'High-Performance & Cost Efficiency',
      description:
         'Our cloud-powered logistics solutions provide real-time inventory updates, multi-warehouse management, and AI-driven fleet tracking, ensuring scalability and efficiency.',
      icon: <ScalableSolutionsIcon />,
   },
   {
      title: 'Continuous Support & Upgrades',
      subtitle: 'Feature Enhancements & Maintenance',
      description:
         'We provide 24/7 technical support, security updates, and feature enhancements to keep logistics platforms competitive, secure, and aligned with industry trends.',
      icon: <ContinuousSupportIcon />,
   },
]

function SupplyChainWhyChoose() {
   return (
      <>
         <WhyChooseOur
            classCustom="fintech_custom_why_choose"
            title={
               'Why Choose Our Supply Chain & Logistics Software Development Services?'
            }
            desc={
               'The company creates safe, robust and advanced logistics solutions which boost supply chain efficiency while increasing automation and supply chain transparency.  Here’s why businesses choose Benzatine:'
            }
            cardData={featureCards}
            // otherUi={true}
         />
      </>
   )
}

export default SupplyChainWhyChoose
